import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=e6d54f0a&"
import script from "./UpgradeModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports